import initSwiperSections from './sections/swiper';

window.swiperInstances = initSwiperSections();
